import { ifProp, theme } from 'styled-tools';
import { css } from 'styled-components';
import styled from './styled.js';
import './chunk-79dadc73.js';
import 'react';
import 'hoist-non-react-statics';
import { a as as } from './as-39ca1b5e.js';
import '@emotion/is-prop-valid';
import { bool } from 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
var Divider = styled(Box).withConfig({
  displayName: "Divider",
  componentId: "f1uok4-0"
})(["border-color:currentColor;border-style:solid;opacity:0.2;", ";", ";"], ifProp("vertical", css(["margin:0 1em;min-height:100%;width:0;border-width:0 0 0 1px;"]), css(["margin:1em 0;height:0;border-width:1px 0 0 0;"])), theme("Divider")); // @ts-ignore

Divider.propTypes = {
  vertical: bool
};
var Divider$1 = as("hr")(Divider);
export default Divider$1;